import { DEFAULT_FH_CONFIG } from './config.js';
function asFh(hand) {
    return hand;
}
function handOver(hand, matchFinished) {
    return matchFinished || hand.phase === 'handComplete' || hand.phase === 'abandoned';
}
/** Config-aware factory. The core's `VisibilityPolicy` does not receive the
 *  match config, so the module's exported policy is built from the defaults;
 *  a reducer that can thread config should call this instead. */
export function fhVisibilityFor(config) {
    return {
        holdings(hand, viewerSeat, matchFinished) {
            const h = asFh(hand);
            const n = h.secret.holdings.length;
            const over = handOver(hand, matchFinished);
            const contract = h.contract;
            const exposed = contract?.mode === 'openMisere' && h.extra?.openMisereExposed === true;
            const sittingOut = h.extra?.sittingOut ?? null;
            return Array.from({ length: n }, (_, seat) => {
                if (over)
                    return 'cards';
                // Rules §5.3: face down for the whole hand, for every viewer.
                if (sittingOut !== null && seat === sittingOut)
                    return 'faceDown';
                // Edge #7: exposure happens as play begins, and only the contractor's hand.
                if (exposed && contract && seat === contract.contractor)
                    return 'cards';
                if (viewerSeat !== null && seat === viewerSeat)
                    return 'cards';
                return 'count';
            });
        },
        kitty(hand, _viewerSeat, matchFinished) {
            // Never 'cards' mid-hand for anyone: the contractor sees the kitty because
            // those three cards are in their holding, not because the pile is public.
            return handOver(hand, matchFinished) ? 'cards' : 'count';
        },
        discards(hand, viewerSeat, matchFinished) {
            const h = asFh(hand);
            if (handOver(hand, matchFinished)) {
                return config.revealDiscardAtHandEnd ? 'cards' : 'count';
            }
            if (!h.extra?.discardResolved)
                return 'hidden';
            // Edge #10: dead and unseen by everyone *else* — only the fact that three
            // cards went back is public. The contractor chose them and remembers
            // them, as any player at a real table would, and the bot and the coach
            // need that too: a misère contractor who forgets burying A♥ plays as if
            // it might still be out to duck under.
            return viewerSeat !== null && h.contract?.contractor === viewerSeat ? 'cards' : 'count';
        },
    };
}
export const fhVisibility = fhVisibilityFor(DEFAULT_FH_CONFIG);
//# sourceMappingURL=visibility.js.map